import axios from 'axios';

import { URL_CONSTANTS } from '../constants/urlConstants';

import { loadCubeQuery } from './cubejs.service';

class ApiService {
  async get(url, config = {}) {
    const response = await axios.get(URL_CONSTANTS.API.BASE_URL + url, config);
    return response.data;
  }

  async postAuditLog(url, payload) {
    const response = await axios.post(
      URL_CONSTANTS.AUDIT_LOG.baseUrl + url,
      payload
    );
    return response.data;
  }

  async post(url, payload) {
    const response = await axios.post(
      URL_CONSTANTS.API.BASE_URL + url,
      payload
    );
    return response.data;
  }

  async userManagementPost(url, payload) {
    const response = await axios.post(
      URL_CONSTANTS.CREW_MANAGEMENT.baseUrl + url,
      payload
    );
    return response.data;
  }

  async put(url, payload) {
    const response = await axios.put(URL_CONSTANTS.API.BASE_URL + url, payload);
    return response.data;
  }
  async patch(url, payload) {
    const response = await axios.patch(
      URL_CONSTANTS.API.BASE_URL + url,
      payload
    );
    return response.data;
  }

  async delete(url) {
    const response = await axios.delete(URL_CONSTANTS.API.BASE_URL + url);
    return response.data;
  }

  async getWithDiffBaseUrl(url, payload, baseUrl = URL_CONSTANTS.API.BASE_URL) {
    const response = await axios.get(baseUrl + url, {
      ...(payload && {
        params: payload,
      }),
    });
    return response.data;
  }

  async postWithDiffBaseUrl(
    url,
    payload,
    baseUrl = URL_CONSTANTS.API.BASE_URL,
    headers = ''
  ) {
    const response = await axios.post(baseUrl + url, payload, headers);
    return response.data;
  }

  async patchWithDiffBaseUrl(
    url,
    payload,
    baseUrl = URL_CONSTANTS.API.BASE_URL
  ) {
    const response = await axios.patch(baseUrl + url, payload);
    return response.data;
  }

  async deleteWithDiffBaseUrl(
    url,
    payload,
    baseUrl = URL_CONSTANTS.API.BASE_URL
  ) {
    const response = await axios.delete(baseUrl + url, payload);
    return response.data;
  }

  async putWithDiffBaseUrl(url, payload, baseUrl = URL_CONSTANTS.API.BASE_URL) {
    const response = await axios.put(baseUrl + url, payload);
    return response.data;
  }

  formatUrl(formatString, ...args) {
    return formatString.replace(/%s/g, () => args.shift());
  }
  async fetchInvoiceEmailCount(invoice_id) {
    const result = await loadCubeQuery({
      query: {
        measures: ['EmailEvents.sent'],
        filters: [
          {
            member: 'EmailEvents.sourceType',
            operator: 'equals',
            values: ['CLIENT'],
          },
          {
            member: 'EmailEvents.sourceTag',
            operator: 'equals',
            values: ['INVOICE_PAGE'],
          },
          {
            member: 'EmailEvents.sourceId',
            operator: 'equals',
            values: [String(invoice_id)],
          },
        ],
      },
    });

    if (result.error) {
      console.error('fetchInvoiceEmailCount', result.message);
      return 0;
    }

    return result.data?.[0]?.['EmailEvents.sent'] ?? 0;
  }

  async fetchInvoiceEmailList(invoice_id) {
    const response = await loadCubeQuery({
      query: {
        dimensions: [
          'EmailEventsFinalStatus.sesMessageId',
          'EmailEventsFinalStatus.sourceType',
          'EmailEventsFinalStatus.sourceTag',
          'EmailEventsFinalStatus.sourceId',
          'EmailEventsFinalStatus.finalStatus',
          'EmailEventsFinalStatus.triggeredAt',
          'EmailEventsFinalStatus.bodyText',
          'EmailEventsFinalStatus.subject',
        ],
        filters: [
          {
            member: 'EmailEventsFinalStatus.sourceType',
            operator: 'equals',
            values: ['CLIENT'],
          },
          {
            member: 'EmailEventsFinalStatus.sourceTag',
            operator: 'equals',
            values: ['INVOICE_PAGE'],
          },
          {
            member: 'EmailEventsFinalStatus.sourceId',
            operator: 'equals',
            values: [String(invoice_id)],
          },
        ],
        order: {
          'EmailEventsFinalStatus.triggeredAt': 'desc',
        },
      },
    });

    if (response.error) {
      console.error('fetchInvoiceEmailList', response.message);
      return [];
    }

    return response.data;
  }
}

export default new ApiService();
